<template>
  <div
    class="wrap"
    v-loading.fullscreen.lock="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
  >
    <div class="top">
      <div class="top_item" v-if="allCount" @click="linkToAll">
        <div class="txt1">{{ allCount }}</div>
        <div class="txt2">报名企业数</div>
      </div>
      <div class="top_item" v-if="allArea" @click="linkToAll">
        <div class="txt1">{{ allArea }}</div>
        <div class="txt2">总面积</div>
      </div>
    </div>
    <div class="box">
      <div class="title">报名数按展区</div>
      <div
        class="item"
        @click="linkToArea(item)"
        v-for="(item, index) in list"
        :key="'area-' + index"
      >
        <p>
          展区：<span class="txt3">{{ item.areaName }}</span>
        </p>
        <span
          >企业数：<span class="txt3">{{ item.count }}</span></span
        >
        <span style="padding-left: 10px"
          >总面积：<span class="txt3">{{ item.area }}</span></span
        >
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
    <div class="empty" v-if="empty">暂无数据</div>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      page: 1,
      size: 99,
      totalCount: 0,
      count: 0,
      list: [],
      info: null,
      allCount: 0,
      allArea: 0,
      loading: true,
      empty: false,
    };
  },
  methods: {
    ...mapActions({
      applyOMGetTotal: "mobileBackend/applyOMGetTotal",
    }),
    async init() {
      let res = await this.applyOMGetTotal({
        exhibitionId: this.$route.query.id,
        pageIndex: this.page,
        pageSize: this.size,
      });
      //console.log(res, 11111);
      this.info = res || null;
      if (res && res.items.length > 0) {
        this.list = res.items;
        res.items.forEach((e) => {
          this.allCount += e.count;
          this.allArea += e.area;
        });
        //console.log("res", res);
      }
      if (res.items.length === 0) {
        this.empty = true;
      }
      if (res) {
        this.loading = false;
      }
    },
    load() {
      this.count += 2;
    },
    linkToArea(item) {
      this.$router.push(
        `/mobile-backend/ex-company-list?dePjNameGroupId=${item.dePjNameGroupId}&exhibitionId=${item.exhibitionId}`
      );
    },
    linkToAll() {
      this.$router.push(
        `/mobile-backend/ex-all-company-list?exhibitionId=${this.$route.query.id}`
      );
    },
  },
  created() {
    document.title = "展区列表";
    this.init();
  },
};
</script>

<style lang="scss" scoped>
.wrap {
  padding: 15px;
}
.top {
  display: flex;
  justify-content: space-between;
  margin-bottom: 15px;
  &_item {
    width: calc(50% - 7px);
    background-color: #fff;
    box-shadow: 0 3px 5px 0 rgba(0, 85, 181, 0.2);
    border-radius: 10px;
    text-align: center;
  }
}
.box {
  .title {
    font-size: 15px;
    color: #333;
    font-weight: 700;
    line-height: 1.5;
    padding-bottom: 5px;
  }
  .item {
    background-color: #fff;
    border-radius: 10px;
    font-size: 15px;
    color: #666;
    padding: 15px;
    position: relative;
    margin-bottom: 15px;
    .el-icon-arrow-right {
      position: absolute;
      right: 15px;
      top: 15px;
    }
    p {
      margin-bottom: 5px;
    }
  }
}
.txt1 {
  font-size: 30px;
  font-weight: 600;
  color: #0782ff;
  padding-top: 8px;
}
.txt2 {
  font-size: 13px;
  color: #999;
  padding-bottom: 10px;
}
.txt3 {
  font-size: 15px;
  color: #333;
}
.empty {
  line-height: 100px;
  text-align: center;
  color: #333;
}
</style>
